import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // clear field error while typing
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));

        setApiError("");
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Enter a valid email";
        }

        if (!formData.password.trim()) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 5) {
            newErrors.password = "Password must be at least 5 characters";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();



        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setApiError("");

        try {
            const response = await fetch("https://orisoftpl.com/backend/api/admin/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                credentials: "include",
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) {
                setApiError(data.message || "Invalid credentials");
                return;
            }

            // ✅ Add these two lines
            console.log("Status:", response.status);
            console.log("Response data:", data);

            localStorage.setItem("admin_token", data.token);
            localStorage.setItem("admin_user", JSON.stringify(data.user)); // ✅ save user

            navigate("/admin");

        } catch (error) {
            setApiError("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
            <div className="w-full max-w-md">

                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-primary">
                        Admin Panel
                    </h2>
                </div>

                <div className="card bg-white shadow-xl p-8">

                    {apiError && (
                        <div className="alert bg-transparent border-red-500 mb-4 text-red-500 text-sm">
                            <span className="text-red-500">{apiError}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">

                        {/* Email */}
                        <div>
                            <label className="label">
                                <span className="label-text">Email</span>
                            </label>

                            <input
                                type="email"
                                name="email"
                                placeholder="Enter email"
                                className={`input input-bordered w-full ${errors.email ? "input-error" : ""
                                    }`}
                                value={formData.email}
                                onChange={handleChange}
                            />

                            {errors.email && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.email}
                                </p>
                            )}
                        </div>

                        {/* Password */}
                        <div>
                            <label className="label">
                                <span className="label-text">Password</span>
                            </label>

                            <input
                                type="password"
                                name="password"
                                placeholder="Enter password"
                                className={`input input-bordered w-full ${errors.password ? "input-error" : ""
                                    }`}
                                value={formData.password}
                                onChange={handleChange}
                            />

                            {errors.password && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.password}
                                </p>
                            )}
                        </div>

                        <button
                            type="submit"
                            className={`btn btn-primary w-full text-white ${loading ? "btn-disabled" : ""
                                }`}
                            disabled={loading}
                        >
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div >
    );
}